import {ExpandContentHandleClick} from 'helpers-ga4';
class SmoothAccordion extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('.accordion__trigger');
    const content = this.querySelector('.accordion__content');
    if (!trigger || !content) return;

    if (trigger.hasAttribute('data-smooth-initialized')) return;
    trigger.setAttribute('data-smooth-initialized', 'true');
    this.addEventListener('click', ExpandContentHandleClick);

    this.isAnimating = false;
    this.isVisible = true;

    content.style.overflow = 'hidden';
    content.style.transition = 'max-height 0.4s ease';

    const isInitiallyOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isInitiallyOpen) {
      this.setAttribute('data-open', 'true');
      requestAnimationFrame(() => {
        content.style.maxHeight = `${content.scrollHeight}px`;
      });
      setTimeout(() => {
        content.style.overflowY = 'auto';
      }, 600);
    } else {
      this.removeAttribute('data-open');
      content.setAttribute('hidden', '');
      content.style.maxHeight = '0px';
    }

    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const ariaExpanded = trigger.getAttribute('aria-expanded') === 'true';
      const contentVisible = !content.hasAttribute('hidden');
      const maxHeight = parseFloat(content.style.maxHeight) || 0;
      const isOpen = ariaExpanded && contentVisible && maxHeight > 0;

      if (this.isAnimating) return;

      if (isOpen) {
        this.isAnimating = true;
        trigger.setAttribute('aria-expanded', 'false');
        this.removeAttribute('data-open');

        content.style.overflowY = 'hidden';
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Double rAF
            content.style.maxHeight = '0px';
          });
        });

        const handleTransitionEnd = () => {
          if (!this.isVisible) return;
          trigger.setAttribute('aria-expanded', 'false');
          content.setAttribute('hidden', '');
          content.removeEventListener('transitionend', handleTransitionEnd);
          this.isAnimating = false;
        };

        content.removeEventListener('transitionend', handleTransitionEnd);
        content.addEventListener('transitionend', handleTransitionEnd);

        setTimeout(() => {
          if (this.isAnimating) {
            content.setAttribute('hidden', '');
            content.removeEventListener('transitionend', handleTransitionEnd);
            this.isAnimating = false;
          }
        }, 500);
      } else {
        const group = this.dataset.accordionGroup;
        if (group) {
          const accordionsInGroup = document.querySelectorAll(
            `smooth-accordion[data-accordion-group="${group}"]`,
          );
          accordionsInGroup.forEach((el) => {
            if (el === this) return;
            const otherTrigger = el.querySelector(
              '.accordion__trigger[aria-expanded="true"]',
            );
            const otherContent = el.querySelector('.accordion__content');
            if (otherTrigger && otherContent) {
              otherTrigger.setAttribute('aria-expanded', 'false');
              el.removeAttribute('data-open');
              otherContent.style.overflowY = 'hidden';
              otherContent.style.maxHeight = otherContent.scrollHeight + 'px';
              requestAnimationFrame(() => {
                otherContent.style.maxHeight = '0px';
              });
              const handleOtherTransitionEnd = () => {
                if (!el.isVisible) return;
                otherContent.setAttribute('hidden', '');
                otherContent.removeEventListener(
                  'transitionend',
                  handleOtherTransitionEnd,
                );
              };
              otherContent.addEventListener(
                'transitionend',
                handleOtherTransitionEnd,
              );
            }
          });
        }

        this.isAnimating = true;
        trigger.setAttribute('aria-expanded', 'true');
        this.setAttribute('data-open', 'true');
        content.removeAttribute('hidden');
        content.style.maxHeight = '0px';

        requestAnimationFrame(() => {
          content.style.maxHeight = `${content.scrollHeight}px`;
        });

        const handleOpenEnd = () => {
          if (!this.isVisible) return;
          content.removeEventListener('transitionend', handleOpenEnd);
          content.style.overflowY = 'auto';
          this.isAnimating = false;
        };

        content.removeEventListener('transitionend', handleOpenEnd);
        content.addEventListener('transitionend', handleOpenEnd);

        setTimeout(() => {
          if (this.isAnimating) {
            content.removeEventListener('transitionend', handleOpenEnd);
            content.style.overflowY = 'auto';
            this.isAnimating = false;
          }
        }, 500);
      }
    });
  }
}

if (!customElements.get('smooth-accordion')) {
  customElements.define('smooth-accordion', SmoothAccordion);
}